.empty-results-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  & > p {
    font-size: 1.6rem;
    line-height: 2rem;
    color: #f2f3f5;
  }
}

.container {
  display: grid;
  position: relative;
  grid-gap: 1.6rem;
  font-size: 1.6rem;
  overflow: auto;
  flex: 1;
  grid-auto-rows: max-content;
  padding: 1.6rem;

  @media screen and (min-width: 420px) {
    grid-template-columns: 1fr;
  }

  @media screen and (min-width: 750px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 1124px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media screen and (min-width: 1440px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media screen and (min-width: 1920px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
}
